var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 0.375C9.20117 0.375 11.75 2.89453 11.75 6C11.75 8.10938 11.0469 8.75391 7.29688 14.7305C6.74023 15.6094 5.48047 15.6094 4.92383 14.7305C1.17383 8.75391 0.5 8.10938 0.5 6C0.5 2.92383 2.99023 0.375 6.125 0.375ZM6.125 13.9688C9.875 7.93359 10.3438 7.61133 10.3438 6C10.3438 3.68555 8.43945 1.78125 6.125 1.78125C3.78125 1.78125 1.90625 3.68555 1.90625 6C1.90625 7.61133 2.375 7.99219 6.125 13.9688ZM3.78125 6C3.78125 4.71094 4.80664 3.65625 6.125 3.65625C7.41406 3.65625 8.46875 4.71094 8.46875 6C8.46875 7.31836 7.41406 8.34375 6.125 8.34375C4.80664 8.34375 3.78125 7.31836 3.78125 6Z",
    fill: "#DFEC49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.7d35228bd328a7c9dacda90f77935768.svg";
export { ForwardRef as ReactComponent };